import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Section from './Section'
import styles from './GettingStarted.module.scss'
import Divider from '../../Shared/Divider/Divider'
import Analytics from 'analytics'

const primaryButtonClasses = classnames(
  'button',
  'button--primary',
  styles.submitButton
)

const firstSectionClassName = classnames (
  styles.section,
  styles.firstSection
)

const GettingStarted = (props) => {
  const {
    goToNextSection,
    linkHref,
  } = props

  const handleGetStartedClick = () => {
    Analytics.track('User clicks Lets Get Started')
    goToNextSection()
  }

  const handleEmailClick = () => {
    Analytics.track('User clicks Private Wealth Management')
  }

  return (
    <div className={styles.GettingStarted}>
      <p className={styles.subDescription}>
        Welcome to Ellevest Private Wealth.
        To finish setting up your accounts we need
        a little more information about you.
      </p>
      <Section
        header="1. About You"
        description="To begin, we need to collect some personal information."
        handyNotes={[
          'Your employer info',
          'Your personal ID if you’re not a US citizen'
        ]}
        className={firstSectionClassName} />
      <Divider className={styles.divider} />
      <Section
        header="2. Your Accounts"
        description="Next, we’ll confirm the names and types of accounts you’re opening."
        handyNotes={[
          `The names and details of any significant people you will name in your
           account (beneficiaries, trustees, grantors etc.)`
        ]}
        className={styles.section} />
      <Divider className={styles.divider} />
      <Section
        header="3. Review & Submit"
        description="Finally, you’ll have a chance to review all your information
        before submitting it to us. We’ll make sure everything’s in order before
        we send you the final forms for you to sign."
        className={styles.section} />
      <div className={styles.bottomSection}>
        <button className={primaryButtonClasses} type="submit" onClick={handleGetStartedClick}>Let’s Get Started</button>
        <div className={styles.questions}>
          Questions? {<a href={linkHref} onClick={handleEmailClick}>Contact</a>} our private
          Wealth Management team.
        </div>
      </div>
    </div>
  )
}

GettingStarted.propTypes = {
  goToNextSection: PropTypes.func.isRequired,
  linkHref: PropTypes.string.isRequired,
}

export default GettingStarted



// WEBPACK FOOTER //
// ./src/components/Onboarding/GettingStarted/v2/GettingStarted.jsx